import { createContext, useContext } from "react";

/**
 * True for pages rendered inside CreativeLandingShell. The song generator
 * (pages/Home.tsx) is the /ai-music-generator page in the shell, and also the
 * generator embedded in the genre and SEO song pages under the app Layout, so
 * it reads this to switch to the landing look only inside the shell.
 *
 * Kept out of CreativeLandingShell.tsx so reading it doesn't pull the shell's
 * landing stylesheets into pages that never render the shell.
 */
export const CreativeLandingShellContext = createContext(false);

export function useInCreativeLandingShell(): boolean {
  return useContext(CreativeLandingShellContext);
}
